import { FeaturedCategoryDto } from '../../dto/featuredcategory/featuredcategorydto';
import { MiddlewareDtoImpl } from '../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../middlewareapiresponse';

export interface FeaturedCategoriesResponse extends MiddlewareAPIResponse 
{
    getFeaturedCategoryDto(): FeaturedCategoryDto;
}

export class FeaturedCategoriesResponseDtoImpl extends MiddlewareDtoImpl implements FeaturedCategoriesResponse 
{
    private featuredCategoryDetailsRespnseDto : FeaturedCategoryDto;

    getFeaturedCategoryDto(): FeaturedCategoryDto
    {
        return this.featuredCategoryDetailsRespnseDto;
    }
    setFeaturedCategoryDtos(featuredCategoryDetailsRespnseDtos: FeaturedCategoryDto)
    {
        this.featuredCategoryDetailsRespnseDto = featuredCategoryDetailsRespnseDtos;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesresponse.tsx